import { formatDate } from '@angular/common';
import { Customer, CustomerStatementRow } from '../models/customer.model';

const doubleFormatter = new Intl.NumberFormat('en', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
});

export const getHtmlForCustomerStatement = (
    rows: CustomerStatementRow[],
    customer: Customer,
    start: Date,
    end: Date,
) => {
    let startingBalance = rows[0].balanceAfter - rows[0].changeAmount;
    startingBalance = startingBalance !== 0 ? -startingBalance : startingBalance;
    const lastRow = rows[rows.length - 1];
    const lastBalance = lastRow.balanceAfter !== 0 ? -lastRow.balanceAfter : lastRow.balanceAfter;
    return `
<!doctype html>
<html lang='ar' dir='rtl'>
<head>
    <meta charset='UTF-8'>
    <meta name='viewport'
          content='width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0'>
    <meta http-equiv='X-UA-Compatible' content='ie=edge'>
    <link rel='preconnect' href='https://fonts.googleapis.com'>
    <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin>
    <link href='https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Arabic:wght@100;200;300;400;500;600;700&display=swap' rel='stylesheet'>
    <title>كشف حساب عميل</title>
</head>
<style>
    * {
        font-family: "IBM Plex Sans Arabic", sans-serif;
    }
    body {
        margin: 0;
        padding: 0.7rem;
        font-size: 0.60rem;
    }
    table {
        border-collapse: collapse;
        border-spacing: 1px;
        direction: rtl;
        width: 100%;
        table-layout: fixed;
        border: 1px solid #dededf;
        padding: 0.5rem 0.7rem;
    }
    th {
        border: 1px solid #dededf;
        background-color: #eceff1;
        color: #000000;
        padding: 5px;
    }
    td {
        border: 1px solid #dededf;
        background-color: #ffffff;
        color: #000000;
        padding: 5px;
    }
</style>
<body onload='window.print();' onafterprint='
      const isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
      if (!isAndroid) {
          window.close();
      }
  '>
    <div class='w-full flex flex-column justify-content-center'>
        <span class='text-center text-xl'>كشف حساب عميل</span>
        <span class='text-center text-lg underline'>${customer.name}: ${customer.code}</span>
        <span class='text-center text-lg'>${formatDate(start, 'yyyy-MM-dd', 'en')} - ${formatDate(end, 'yyyy-MM-dd', 'en')}</span>
    </div>
    <table class='table-auto mt-2' dir='rtl'>
        <thead>
            <tr>
                <th class='text-center'>التاريخ</th>
                <th class='text-center'>الوصف</th>
                <th class='text-center'>مدين</th>
                <th class='text-center'>دائن</th>
                <th class='text-center'>الرصيد</th>
            </tr>
            <tr>
                <td class='text-center font-bold' colspan='4'>الرصيد الابتدائي</td>
                <td class='text-center font-bold' dir='ltr'>${doubleFormatter.format(startingBalance)}</td>
            </tr>
        </thead>
        <tbody>
            ${rows
                .map((row) => {
                    return `
                    <tr>
                        <td class='text-center'>${formatDate(row.createdAt, 'yyyy-MM-dd', 'en')}</td>
                        <td class='text-center'>${row.description}</td>
                        <td class='text-center' dir='ltr'>${row.changeAmount > 0 ? doubleFormatter.format(Math.abs(row.changeAmount)) : doubleFormatter.format(0)}</td>
                        <td class='text-center' dir='ltr'>${row.changeAmount < 0 ? doubleFormatter.format(Math.abs(row.changeAmount)) : doubleFormatter.format(0)}</td>
                        <td class='text-center' dir='ltr'>${doubleFormatter.format(-row.balanceAfter)}</td>
                    </tr>`;
                })
                .join('')}
        </tbody>
        <tfoot>
            <tr>
                <td class='text-center font-bold' colspan='2'>المجموع</td>
                <td class='text-center font-bold'>${doubleFormatter.format(getSumOfCredit(rows))}</td>
                <td class='text-center font-bold'>${doubleFormatter.format(getSumOfDebit(rows))}</td>
                <td class='text-center font-bold' dir='ltr'>${doubleFormatter.format(lastBalance)}</td>
            </tr>
        </tfoot>
    </table>
</body>
<link rel='stylesheet' href='https://unpkg.com/primeflex@latest/primeflex.css'>
<script src='/assets/scripts/qrious.min.js'></script>
</html>
  `;
};

function getSumOfDebit(rows: CustomerStatementRow[]) {
    let sum = 0;
    for (const row of rows) {
        if (row.changeAmount < 0) {
            sum += row.changeAmount;
        }
    }
    return Math.abs(sum);
}

function getSumOfCredit(rows: CustomerStatementRow[]) {
    let sum = 0;
    for (const row of rows) {
        if (row.changeAmount > 0) {
            sum += row.changeAmount;
        }
    }
    return Math.abs(sum);
}
